export const API_URL =
  (import.meta as any).env.VITE_API_URL ||
  "https://instapayapi.adgigpay.com.ng/";
